import React from 'react';
import { ReactNode } from "react";

export interface IAppConfig
{
  versionNumber:string;
  companyDisplayName:string;
  companyLegalName: string;
  companyMainPhone:string;
  infoeMail:string;
  supporteMail:string;
  supportPhone:string;
  legalEMail:string;
  contactPageAPIUrl:string;
  address:IAddress;
  operatingHours:IOperatingHours;

  images: IImagePath[];
  faqData: IFAQDataDoc_v2_WithSUB;
  
  ContactUsPage: IPageContactUs;
  AboutPage: IPageAbout;

  homePageCarouselItems?:any;
  homePageFeaturesList?:any;
  homePageMetrics?:any;
  
  ServicesPage1?:any;
  ServicesPage2?:any;
  
  HomePageMetrcsCSSValue?:number;
  hideContactAddressInfo?:boolean;
}//end:


export class AppConfig implements IAppConfig{
    
    constructor(public versionNumber: string,
                public companyDisplayName: string, 
                public companyLegalName: string, 
                public companyMainPhone: string,

                public infoeMail:string,
                public supporteMail:string,

                public supportPhone:string,
                public legalEMail:string,
                public contactPageAPIUrl:string,
                public address: IAddress,
                public operatingHours: IOperatingHours,
                public images:  IImagePath[],
                public faqData: IFAQDataDoc_v2_WithSUB,
                public ContactUsPage: IPageContactUs,
                public AboutPage: IPageAbout,
                

                public homePageCarouselItems?:any,
                public homePageFeaturesList?:any,
                public homePageMetrics?:any,

                public ServicesPage1?:any,
                public ServicesPage2?:any,

                public HomePageMetrcsCSSValue?:number,
                public hideContactAddressInfo?:boolean
                ) {
    }//end:con
  }//end:class


export interface IOperatingHours {
  MF: string;
  SA: string;
  SU: string;
}

export class OperatingHours implements IOperatingHours {
    constructor(public MF:string, public SA: string, public SU: string){}
}//end:




export interface IAddress{
  street1:string;
  street2:string;
  city: string;
  state: string;
  zip: string;
} //end:

export interface IImagePath {
    imageName:string;
    imagePath:string;
    remarks?:string;
}

export class CompanyAddress implements IAddress {
    constructor(public street1:string, public street2:string, public city:string, public state:string, public zip:string ){}
}


export interface IAppConfigFeatures{
  feature1Title:string;
  feature1Description:string
  feature1Image:string;
}//end:




export interface IInsuranceCategories {
  businessInsurance: ICategoryItem[];
  personalInsurance: ICategoryItem[];
}

export interface ICategoryItem {
  id:number;
  title:string;
  description:string;
}

export interface IItemList {
  Id: number;
  Title: string;
  Description?:string;
  TagLine?:string;
  TagLineUrl?:string;
  ImageLink?: string;
  AltText?:string;
  Items: IItem[];
}//end:

export interface ItemListBenefits {
  
  Title: string;
  Description?:string;
  ImageLink?: string;
  AltText?:string;
  Items: IItemBenefit[];
}//end:


export interface IItem {
  Title: string;
  Description: string;
  ImageLink: string;
  AltText: string;
  UrlLink?:string;
  SubItems?: ISubItem[]
  ItemFacts?: IItemFact[];
  Benefits?: IItemBenefit[];
}//end:

export interface ISubItem {
  Title: ReactNode;
  Description: ReactNode;
}

export interface IItemFact {
  Title: ReactNode;
  Description: ReactNode;
}

export interface IItemBenefit {
  benefit: ReactNode;
  example: ReactNode;
}



export interface IMetricsRow {
  Title:string;
  SubTitle:string;
  Text:string;
}//end:

export interface IMetricsRowData {
  Headline:string;
  Rows: IMetricsRow[];
}//end:


export interface IMetricsRow_v2 {
  id: number;
  title:string;
  subTitle:string;
  text:string;
}//end:


export interface IMetricsRowData_v2 {
  title:string;
  subTitle:string;
  rows: IMetricsRow_v2[];
}//end:


export interface IToolTip{
  Title:string;
}

export interface IFAQDataDoc{
  title: string;
  items:IFaqItem[],
}


export interface IFaqItem {
    id?:number;
    category?: string;
    type?:string;
    icon?: string;
    question?:string;
    answer?:string;
}

export interface IFAQDataDoc_v2_WithSUB{
  title: string;
  items:IFaqItemWith_v2_WithSUB[],
}

export interface IFaqItemWith_v2_WithSUB {
    id?:number;
    category?: string;
    type?:string;
    icon?: string;
    question?:string;
    answer?:string;

    items: {
      id?:number;
      question: ReactNode;
      answer: ReactNode;
      category?:string;
      type?:string;
    }[];
}


export interface IPageContactUs {
  Headline: ReactNode 
}//end:


export interface IPageAbout{
  Headline: ReactNode,
  Services: ReactNode
}